<template>
  <v-col
    v-if="mainMenu.length > 0 || error"
    cols="12"
  >
    <v-row v-if="error" justify="center">
      <v-col cols="6" align="center">
        <v-alert
          dense
          outlined
          type="error"
        >
          {{ $t(error) }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-else no-gutters>
      <v-col lg="9" md="8" cols="12" class="menu-container__main">
        <ul>
          <v-row>
            <TheMenuBlock
              v-for="(item, index) in mainMenu"
              :key="index"
              :menuItem="item"/>
          </v-row>
        </ul>
      </v-col>
      <v-col cols="12" md="4" lg="3">
        <v-row no-gutters>
          <TheMenuTeaser
            v-for="(teaser, index) in teaserMenu"
            :key="index"
            :teaser-item="teaser"
          />
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12">
        <TheMenuTripPlanner
          :trip-planner-item="tripPlannerMenu"
        />
      </v-col>
    </v-row>
  </v-col>
  <v-col
    v-else
    cols="12"
  >
    <TheMenuLoader/>
  </v-col>
</template>

<script>
  import TheMenuBlock from './TheMenuBlock.vue'
  import TheMenuTeaser from './TheMenuTeaser.vue'
  import TheMenuTripPlanner from './TheMenuTripPlanner.vue'
  import TheMenuLoader from './TheMenuLoader.vue'

  export default {
    name: 'TheMenuContainer',

    components: {
      TheMenuBlock,
      TheMenuTeaser,
      TheMenuTripPlanner,
      TheMenuLoader,
    },

    computed: {
      error() {
        return this.$store.state.error.menu
      },

      locale() {
        return this.$store.state.locale
      },

      mainMenu() {
        return this.$store.state.menus.mainMenu
      },

      teaserMenu() {
        return this.$store.state.menus.teaserMenu
      },

      tripPlannerMenu() {
        return this.$store.state.menus.tripPlannerMenu
      },
    },
  }
</script>

<style lang="sass" scoped>
  .menu-container
    height: auto
    overflow-x: hidden
    overflow-y: auto
    position: absolute
    padding: 0
    background-color: #fff
    z-index: 10

    &__main
      padding: 20px 100px 0 50px

  @media (max-width: 1263px)
    .menu-container__main
      padding: 60px 50px

  @media (max-width: 960px)
    .menu-container__main
      padding: 0 10px
</style>
